import { render, staticRenderFns } from "./PgaValutazioneOffertaHeaderCreate.vue?vue&type=template&id=2f8d9e36&"
import script from "./PgaValutazioneOffertaHeaderCreate.vue?vue&type=script&lang=ts&"
export * from "./PgaValutazioneOffertaHeaderCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VRow,VSelect,VTextField,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f8d9e36')) {
      api.createRecord('2f8d9e36', component.options)
    } else {
      api.reload('2f8d9e36', component.options)
    }
    module.hot.accept("./PgaValutazioneOffertaHeaderCreate.vue?vue&type=template&id=2f8d9e36&", function () {
      api.rerender('2f8d9e36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/ValutazioneOfferta/Components/PgaValutazioneOffertaHeaderCreate.vue"
export default component.exports